import { useEditor } from "@grapesjs/react";
import { Button, ButtonColors, Modal } from "@talentech/components";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { PageTypes } from "@/App";
import { usePublishTemplateMutation } from "@/redux/reducer/pages.api";
import { CustomCommands } from "@/shared/utils";
import { publishNotice } from "../utils/publishNotice";
import { saveThenPublish } from "../utils/frameSetting";

const PublishTemplateModal = () => {
  const editor = useEditor();
  const [showModal, setShowModal] = useState(false);
  const { id, type } = useParams<{ id: string; type: PageTypes }>();
  const [publishTemplate] = usePublishTemplateMutation();
  const onPublishAction = () => {
    if (type && id) {
      const published = saveThenPublish({
        save: () => editor.store(),
        publish: () => publishTemplate({ type, id }).unwrap(),
      });
      toast.promise(published, {
        success: "Published successfuly",
        error: "Something went wrong",
        pending: "In a second",
      }).then((result) => {
        const notice = publishNotice(
          type === PageTypes.JOB,
          result.added_to_ps
        );
        if (notice) {
          toast.info(notice);
        }
        editor.runCommand(CustomCommands.TEMPLATE_PUBLISH_CLOSE);
      });
    }
  };
  useEffect(() => {
    editor.Commands.add(CustomCommands.TEMPLATE_PUBLISH_OPEN, () => {
      setShowModal(true);
    });

    editor.Commands.add(CustomCommands.TEMPLATE_PUBLISH_CLOSE, () => {
      setShowModal(false);
    });

    editor.Commands.add(CustomCommands.TEMPLATE_PUBLISH_SAVE, onPublishAction);
  }, []);

  return (
    <>
      <Modal
        title="Publish template"
        showModal={showModal}
        onClose={() => editor.runCommand(CustomCommands.TEMPLATE_PUBLISH_CLOSE)}
        buttons={[
          <Button
            onClick={() =>
              editor.runCommand(CustomCommands.TEMPLATE_PUBLISH_CLOSE)
            }
            label="Cancel"
            outline
            key={"cancel"}
          />,
          <Button
            onClick={() =>
              editor.runCommand(CustomCommands.TEMPLATE_PUBLISH_SAVE)
            }
            label="Publish"
            key={"publish"}
            color={ButtonColors.PRIMARY}
          />,
        ]}
      >
        <p>
        Do you wish to proceed with publishing this template? All current changes will be immediately visible to users.
        </p>
      </Modal>
    </>
  );
};

export default PublishTemplateModal;
